import { Directive, inject, Input } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Directive({ selector: '[bnWebUiTrimSpaces]' })
export class TrimSpacesDirective {
  private ngControl = inject(NgControl);

  @Input()
  public set bnTrimSpaces(trimSpaces: boolean) {
    if (!trimSpaces || !this.ngControl.valueAccessor) return;

    trimValueAccessor(this.ngControl.valueAccessor);
  }

  constructor() {
    const ngControl = this.ngControl;

    if (ngControl.valueAccessor) {
      this.ngControl = ngControl;
    }
  }
}

function trimValueAccessor(valueAccessor: ControlValueAccessor): void {
  const original = valueAccessor.registerOnChange;

  valueAccessor.registerOnChange = (fn: (_: unknown) => void): void =>
    original.call(valueAccessor, (value: unknown) => fn(typeof value === 'string' ? value.trim() : value));
}
